export const successValidationStatus = 'success';
export const errorValidationStatus = 'error';